import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private static localApi = 'http://localhost:8100';

  private static testApi = 'https://api-dev.rtrtg.de/billing-portal';

  private static liveApi = 'https://api-stage.rtrtg.de/billing-portal';

  private static testToken = '9562a313-61e0-4661-a2a3-1361e06661dd';

  private static liveToken = 'b603f86b-4212-439e-83f8-6b4212339e95';

  /**
   * Returns the current Api Url.
   */
  public static getCurrentApi(): string {
    if (environment.branch === 'produktiv') {
      return ApiService.liveApi;
    } else if (environment.branch === 'abnahme') {
      return ApiService.testApi;
    }
    return ApiService.localApi;
  }

  /**
   * Returns the current API Token
   */
  public static getCurrentApiToken(): string {
    if (environment.branch === 'produktiv') {
      return this.liveToken;
    } else if (environment.branch === 'abnahme') {
      return this.testToken;
    }
    return '';
  }

  /**
   * Returns the Local Api Url
   */
  public static getLocalApi(): string {
    return ApiService.localApi;
  }

  /**
   * Returns the Test Api Url
   */
  public static getTestApi(): string {
    return ApiService.testApi;
  }

  /**
   * Returns the Live Api Url
   */
  public static getLiveApi(): string {
    return ApiService.liveApi;
  }

  /**
   * Returns the Local Api Token
   */
  public static getLocalToken(): string {
    return '';
  }

  /**
   * Returns the Test Api Token
   */
  public static getTestToken(): string {
    return ApiService.testToken;
  }

  /**
   * Returns the Live Api Token
   */
  public static getLiveToken(): string {
    return ApiService.liveToken;
  }
}
